const defaultTheme = {
    theme: {
        colors: {
            base : '#171717',
            second : '#333333',
            third : '#DA0037',
            fourth : '#EDEDED',
        },
        extend: {},
    },
}

export default defaultTheme
